<!-- 
  Component qui sert à afficher des liens entre des postits et à les gerer
-->

<template>
  <g
    :id="'link'+link.id"
    v-if="parentCoords && childCoords &&properSheet"
    :z="editing? '10':'0'"
    :opacity="opacity"
  >
    <!-- Chaque liens est composé de plusieures lignes svg -->
    <!-- Ligne montrant que le lien est sélectionné -->
    <line
      v-if="selecting"
      :x1="childCoords[shortestLink[1]].x"
      :y1="childCoords[shortestLink[1]].y"
      :x2="parentCoords[shortestLink[2]].x"
      :y2="parentCoords[shortestLink[2]].y"
      :stroke="'#ffa500'"
      stroke-width="5.5"
    />
    <!-- Ligne servant à créer un contour blanc pour améliorer la visibilité du lien -->
    <line
      :x1="childCoords[shortestLink[1]].x"
      :y1="childCoords[shortestLink[1]].y"
      :x2="parentCoords[shortestLink[2]].x"
      :y2="parentCoords[shortestLink[2]].y"
      :stroke="'#fff'"
      stroke-width="4.5"
    />
    <!-- Ligne servant à créer un contour blanc autour de la fleche de début/fin pour améliorer la visibilité du lien -->
    <line
      :x1="childCoords[shortestLink[1]].x"
      :y1="childCoords[shortestLink[1]].y"
      :x2="parentCoords[shortestLink[2]].x"
      :y2="parentCoords[shortestLink[2]].y"
      :stroke="'#fff'"
      :marker-end="markerSelector('rgb(255,255,255)').end"
      :marker-start="markerSelector('rgb(255,255,255)').start"
      stroke-width="3.5"
    />
    <!-- Lien de couleur central avec une fleche de début/fin si nécessaire-->
    <line
      @click="selectLinked"
      :x1="childCoords[shortestLink[1]].x"
      :y1="childCoords[shortestLink[1]].y"
      :x2="parentCoords[shortestLink[2]].x"
      :y2="parentCoords[shortestLink[2]].y"
      :stroke="link.color"
      stroke-width="2.5"
      :marker-end="markerSelector().end"
      :marker-start="markerSelector().start"
    />

    <!-- Ligne transparente servant à enregistrer les events, plus large que les lignes précédentes pour faciliter l'utilisation -->
    <line
      @click.stop.prevent="openEditMenu"
      @click.stop.prevent.right="openEditMenu"
      v-touch:longtap.self="openEditMenu"
      :x1="childCoords[shortestLink[1]].x"
      :y1="childCoords[shortestLink[1]].y"
      :x2="parentCoords[shortestLink[2]].x"
      :y2="parentCoords[shortestLink[2]].y"
      stroke="#00000000"
      stroke-width="18.5"
    />

    <!-- Container du menu édition du lien -->
    <g
      @click.stop.prevent.right="editing = false"
      id="editMenu"
      :transform="`translate(${editMenu.x},${editMenu.y})`"
      v-if="editing===true"
    >
      <!-- Passage en mode html -->
      <foreignObject
        x=0
        y=0
        width="350"
        height="180"
      >
        <div id="menu">

          <!-- Bouton Switch de sens le lien -->
          <button
            :title="$t('tooltip.switch')"
            v-if="this.link.relation !=='inverse' "
            id="inverseRelation"
            @click="sendChanges('inverse')"
            class="menuOption ripple"
          >
            <i :title="this.childPost.contenu">{{shrinkString(this.childPost.contenu,4)}}</i>
            <b-icon
              class="editbutton"
              pack="fas"
              icon="arrow-right"
              size="is-small"
            ></b-icon>
            <i :title="this.parentPost.contenu">{{shrinkString(this.parentPost.contenu,4)}}</i>
          </button>

          <!-- Bouton Switch de sens le lien -->
          <button
            :title="$t('tooltip.switch')"
            v-if="this.link.relation !=='correcte' "
            id="correcteRelation"
            @click="sendChanges('correcte')"
            class="menuOption ripple"
          >
            <i :title="this.childPost.contenu">{{shrinkString(this.childPost.contenu,4)}}</i>
            <b-icon
              class="editbutton"
              pack="fas"
              icon="arrow-left"
              size="is-small"
            ></b-icon>
            <i :title="this.parentPost.contenu">{{shrinkString(this.parentPost.contenu,4)}}</i>
          </button>

          <!-- Bouton Rendre le lien neutre -->
          <button
            :title="$t('tooltip.removeHier')"
            v-if="this.link.relation !=='none' "
            id="removeHierarchy"
            @click="sendChanges('none')"
            class="menuOption ripple"
          >
            <i :title="this.childPost.contenu">{{shrinkString(this.childPost.contenu,4)}}</i>
            <b-icon
              class="editbutton"
              pack="fas"
              icon="window-minimize"
              size="is-small"
            ></b-icon>
            <i :title="this.parentPost.contenu">{{shrinkString(this.parentPost.contenu,4)}}</i>
          </button>

          <!-- Bouton Supprimer le lien -->
          <button
            :title="$t('tooltip.delete')"
            id="deleteRelation"
            @click="promptDeleteLink(link)"
            class="menuOption ripple is-danger"
          >
            <i :title="this.childPost.contenu">{{shrinkString(this.childPost.contenu,4)}}</i>
            <b-icon
              class="editbutton"
              pack="fas"
              icon="unlink"
              size="is-small"
            ></b-icon>
            <i :title="this.parentPost.contenu">{{shrinkString(this.parentPost.contenu,4)}}</i>
          </button>
        </div>
      </foreignObject>
    </g>
  </g>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { postAsync } from '@/http-common'
const { mapState } = createNamespacedHelpers('board')

export default {
  name: 'links',
  data () {
    return {
      opacity: 1,
      selecting: false,
      editing: false,
      editMenu: { x: 0, y: 0 },
      childPost: null,
      parentPost: null
    }
  },
  props: {
    link: Object
  },
  methods: {
    // Methode pour sauvegarder le lien en BDD
    async sendChanges (relation = 'none') {
      this.link.relation = relation

      let url = process.env.URL_SSO_API + 'brainstorming/public/board/' + this.current.id + '/link/' + this.link.id
      // console.log(url)

      let data = new FormData()
      data.append('_method', 'PUT')
      for (let [key, value] of Object.entries(this.link)) {
        data.append(key, value)
      }

      let res = await postAsync(url, data, { 'urlparticipant': this.current.url_participant })

      if (res.status === 200) {
        this.$parent.$parent.editPostLinkActive = false
        this.$parent.$parent.$buefy.toast.open({
          message: this.$i18n.t('toast.modification.success'),
          type: 'is-success',
          position: 'is-bottom'
        })
      } else {
        this.$buefy.toast.open({
          message: this.$i18n.t('toast.network_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      }
    },
    async promptDeleteLink (props) {
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t('dialog.cancel'),
        confirmText: this.$i18n.t('button.supprimer'),
        message: this.$i18n.t('confirm.deleteLink'),
        onConfirm: () => { this.deleteLink(props) }
      })
    },
    async deleteLink (props) {
      let linkToDelete = this.link
      // console.log(linkToDelete.id)
      let url = process.env.URL_SSO_API + 'brainstorming/public/board/' + this.current.id + '/link/' + linkToDelete.id
      let res = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-type': 'application/json; charset=UTF-8', // Indicates the content
          'urlparticipant': this.current.url_participant
        },
        body: JSON.stringify({ id: linkToDelete.id })
      })
      if (res.status === 200) {
        // this.allPosts = this.allPosts.filter(post => post.id !== props.row.id)
        // this.allLinks = this.allLinks.filter(link => link.id !== linkToDelete.id)
        // this.checkChild.splice(props.index, 1)
        // this.checkParent.splice(props.index, 1)
        this.$parent.$buefy.toast.open({
          message: this.$i18n.t('link.supprimer.notification'),
          type: 'is-success',
          position: 'is-bottom'
        })
      } else {
        this.$buefy.toast.open({
          message: this.$i18n.t('toast.network_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      }
    },
    test (e) {
      // console.log(e)
    },
    shrinkString (string, numberOfWords = 3) {
      return string.split(' ').length > numberOfWords ? string.split(' ').slice(0, numberOfWords).join(' ').concat(' ...') : string.split(' ').slice(0, numberOfWords).join(' ')
    },
    openEditMenu (e) {
      this.$parent.$refs.link.forEach(link => {
        if (link.link.id === this.link.id) {
          this.editing = !this.editing
        } else {
          link.editing = false
        }
      })
      // console.log(e)
      if (e.changedTouches && e.changedTouches.length > 0) {
        this.editMenu.x = e.changedTouches[0].clientX - this.$parent.getWidthOffset()
        this.editMenu.y = e.changedTouches[0].clientY - this.$parent.getHeightOffset()
      } else {
        this.editMenu.x = e.clientX - this.$parent.getWidthOffset()
        this.editMenu.y = e.clientY - this.$parent.getHeightOffset()
      }

      this.$parent.getEditingLink()
    },
    selectLinked () {
      this.$parent.$refs.link.forEach(link => {
        link.link.id !== this.link.id ? link.selecting = false : link.selecting = !link.selecting
      })
      if (this.$parent.selectedPosts.includes(this.link.child_post) && this.$parent.selectedPosts.includes(this.link.parent_post) && this.$parent.selectedPosts.length === 2) {
        this.$parent.selectedPosts = []
      } else {
        this.$parent.selectedPosts = []
        this.$parent.selectedPosts.push(this.link.child_post, this.link.parent_post)
      }
    },
    // Methode qui détermine si le lien doit avoir une fleche au début, àla fin, ou pas du tout
    markerSelector (color = this.link.color) {
      let start = ``
      // let start = `url(#line${this.$parent.colors.indexOf(color)})`
      let end = ``
      // let end = `url(#line${this.$parent.colors.indexOf(color)})`
      if (this.link.relation === 'correcte') {
        start = `url(#triangle${this.$parent.colors.indexOf(color)})`
      } else if (this.link.relation === 'inverse') {
        end = `url(#triangle${this.$parent.colors.indexOf(color)})`
      }
      return { start: start, end: end }
    },
    editLink (e) {
      this.selecting = !this.selecting
    }
  },
  computed: {

    nbPosts () {
      return this.postlist.length
    },
    // Getter pour les coordonées du post "enfant"
    childCoords () {
      // l'updater ci dessous ne sert qu'à forcer la mise à jour du computed, lorsqu'on ajoute/supprime un post
      let updater = this.nbPosts
      if (this.$parent.$refs.post.filter(post => { return post.id === this.link.child_post })[0]) { // on check que le post enfant existe
        this.editing = false
        return this.$parent.$refs.post.filter(post => { return post.id === this.link.child_post })[0].anchors // on renvoie les coords des "ancres" du post
      }
      return null
    },
    // Getter pour les coordonées du post "parent"
    parentCoords () {
      // l'updater ci dessous ne sert qu'à forcer la mise à jour du computed, lorsqu'on ajoute/supprime un post
      let updater = this.nbPosts
      if (this.$parent.$refs.post && this.$parent.$refs.post.filter(post => { return post.id === this.link.parent_post })[0]) { // on check que le post parent existe
        this.editing = false
        return this.$parent.$refs.post.filter(post => { return post.id === this.link.parent_post })[0].anchors // on renvoie les coords des "ancres" du post
      }
      return null
    },
    // Getter pour la distance la plus courte entre deux postes
    shortestLink () {
      let distances = []
      if (this.parentCoords && this.childCoords) {
        for (let [childKey, childCoordsSet] of Object.entries(this.childCoords)) {
          for (let [parentKey, parentCoordsSet] of Object.entries(this.parentCoords)) {
            distances.push([Math.hypot(childCoordsSet.x - parentCoordsSet.x, childCoordsSet.y - parentCoordsSet.y), childKey, parentKey]) // on calcule l'hypoténuse entre toutes les ancres des deux postits et on le stock dans le tableau distances
          }
        }
        let min = distances.reduce((a, b) => { // on trouve la plus petite distance dans le tableau
          return a[0] < b[0] ? a : b
        })

        return min
      }
      return null
    },
    //Getter du contenu des postits liés au lien
    contentPosts () {
      let childContent = this.postlist.filter(post => post.id === this.link.child_post)[0] ? this.postlist.filter(post => post.id === this.link.child_post)[0].contenu : null
      let parentContent = this.postlist.filter(post => post.id === this.link.parent_post)[0] ? this.postlist.filter(post => post.id === this.link.parent_post)[0].contenu : null
      return { child: childContent, parent: parentContent }
    },
    // Getter pour vérifier si on est sur la page du lien
    properSheet () {
      if (this.postlist) {
        if (this.postlist.filter(post => { return post.id === this.link.child_post })[0] && this.postlist.filter(post => { return post.id === this.link.parent_post })[0]) {
          return (
            this.postlist.filter(post => { return post.id === this.link.child_post })[0].sheet_id === this.postlist.filter(post => { return post.id === this.link.parent_post })[0].sheet_id &&
            this.postlist.filter(post => { return post.id === this.link.parent_post })[0].sheet_id === this.currentSheet &&
            this.postlist.some(post => post.id === this.link.child_post) &&
            this.postlist.some(post => post.id === this.link.parent_post)
          )
        } else {
          // console.log(false)
        }
      }
      return false
    },
    ...mapState({
      postlist: 'currentBoardPost',
      current: 'current',
      currentSheet: 'currentSheet',
      menu: 'menu',
      linking: 'linking'
    })
  },
  updated () {
    this.childPost = this.postlist.find(post => post.id === this.link.child_post)
    this.parentPost = this.postlist.find(post => post.id === this.link.parent_post)
  },
  mounted () {
    this.childPost = this.postlist.find(post => post.id === this.link.child_post)
    this.parentPost = this.postlist.find(post => post.id === this.link.parent_post)
    let postsToUpdate = this.$parent.$refs.post.filter(post => post.id === this.link.parent_post || this.link.child_post === post.id)
    if (postsToUpdate && postsToUpdate.length > 0 && !postsToUpdate.some(post => post.etat !== 'publie')) {
      postsToUpdate.forEach(post => {
        post.isLinked = true
      })
    }
  }
}
</script>

<style scoped>
#menu {
  border: 1px solid darkgray;
  border-radius: 4px;
  padding: 2px 5px;
  background-color: white;
  width: min-content;
}

.menuOption:hover {
  font-weight: 600;
}
.menuOption {
  font-size: 12px;
  border: 0.75px solid white;
  width: max-content;
  min-height: 20px;
  height: min-content;
  margin: 3px 0px;
  background-color: white;
}

#editLinks {
  color: white;
  border: 2px solid white;
  border-radius: 5px;
  padding: 10px;
  width: max-content;
  height: max-content;
  background-color: #3e6a99;
}
</style>



// WEBPACK FOOTER //
// src/components/board/Links.vue